import React from 'react';
import PropTypes from 'prop-types';

import { useI18n } from '@hydra/common/customHooks';
import { Translate } from '@hydra/common/components';
import { Criterium, CriteriumSkeleton, CriteriumTable } from '@hydra/common/criterium';
import { useReviewContext } from '@hydra/common/context';

export const MAX_AMOUNT_TO_SHOW = 6;

export const MobileTaptargets = ({ criterium }) => {
  const { numeral } = useI18n();
  const { data, url } = criterium;
  const { failingTapTargets, viewport } = data;
  const { variant } = useReviewContext();
  const createTableRow = ({ domRect, failingTapNeighbours, snippet }) => {
    snippet = snippet.trim();
    const width = numeral(domRect.width).format('0,0');
    const height = numeral(domRect.height).format('0,0');
    const size = `${width}x${height}`;
    const overlappingTarget = failingTapNeighbours.length > 0 ? failingTapNeighbours[0].snippet.trim() : '';

    return [
      snippet,
      size,
      overlappingTarget
    ];
  };

  const head = [
    <Translate content='tap_target' key='tap_target' />,
    <Translate content='tap_target_size' key='tap_target_size' />,
    <Translate content='overlapping_target' key='overlapping_target' />
  ];

  const rows = failingTapTargets
    .slice(0, MAX_AMOUNT_TO_SHOW)
    .map(createTableRow);

  let content;
  if (viewport && viewport.isPresent === false) {
    content = variant === 'nocrit' ? <CriteriumSkeleton width='60%' /> : <Translate content='mobile_taptargets_viewport_not_specified' />;
  } else if (viewport && viewport.isValid === false) {
    content = variant === 'nocrit' ? <CriteriumSkeleton width='60%' /> : <Translate content='mobile_taptargets_viewport_invalid' />;
  } else {
    content = failingTapTargets.length > 0
      ? (
        <>
          {variant === 'nocrit' ? <><CriteriumSkeleton /><CriteriumSkeleton width='30%' /></> : <Translate content='mobile_taptargets_ko' />}
          <CriteriumTable head={head} rows={rows} showAmount={3} fixedColumns={[44, 12, 44]} striped />
        </>
        )
      : (variant === 'nocrit' ? <CriteriumSkeleton width='70%' /> : <Translate content='mobile_taptargets_ok' />);
  }

  return (
    <Criterium
      criterium={criterium}
      variables={{ domain: url }}
    >
      {content}
    </Criterium>
  );
};

MobileTaptargets.propTypes = {
  criterium: PropTypes.shape({
    data: PropTypes.shape({
      viewport: PropTypes.shape({
        isPresent: PropTypes.bool,
        isValid: PropTypes.bool
      }),
      failingTapTargets: PropTypes.arrayOf(
        PropTypes.shape({
          snippet: PropTypes.string,
          domRect: PropTypes.shape({
            width: PropTypes.number,
            height: PropTypes.number
          }),
          failingTapNeighbours: PropTypes.arrayOf(
            PropTypes.shape({
              snippet: PropTypes.string
            })
          )
        })
      )
    })
  })
};

export default React.memo(MobileTaptargets);
